export class EchantillonOperateurEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        siret: { key: 'siret', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        cvi: { key: 'cvi', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        fax: { key: 'fax', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        portable: { key: 'portable', optional: true, default: '' }
    };

    id: number;
    raisonSociale: string;
    siret: string;
    adresse: string;
    codePostal: string;
    cvi: string;
    ville: string;
    fax: string;
    date: string;
    telephone: string;
    portable: string;
}
